import { useParams } from 'react-router-dom';
import { useGetThreadQuery } from '../../store/api/threadsApi';
import { CommentItem } from './CommentItem';

export function Comments() {
  const { threadId } = useParams();
  const {
    isLoading: loadingComments,
    data: threadDetailData,
    isError,
  } = useGetThreadQuery(threadId);

  return (
    <div className="mx-auto">
      {loadingComments ? <div className="my-4 text-sm">Loading...</div> : ''}
      {threadDetailData ? (
        <div className="prose-base divide-y divide-gray-200 dark:divide-gray-800 dark:prose-invert">
          <div className="not-prose">
            {threadDetailData.comments.length === 0 ? (
              ''
            ) : (
              <h2 className="my-4 text-lg">Semua balasan</h2>
            )}
          </div>
          {threadDetailData.comments.map((comment) => (
            <div key={comment.id}>
              <CommentItem commentitem={comment} threadId={threadId} />
            </div>
          ))}
        </div>
      ) : (
        ''
      )}
      {isError ? (
        <div className="my-4 text-sm">Failed to load comments</div>
      ) : (
        ''
      )}
    </div>
  );
}
